import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Pagination from '@material-ui/lab/Pagination';
import { TabPane, a11yProps, StyledTab, StyledTabs } from '../../../components/Tabs.js';
import ListingsCardList from '../../../components/listing/ListingsCardList.js';
import ProviderCardList from '../../../components/provider/ProviderCardList.js';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    paddingTop: '1rem',
  },
  appBar: {
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.common.silver}`,
  },
  tabContent: {
    padding: '1rem 0',
  },
  paginationText: {
    padding: '1rem 0',
  },
}));

const TabsPanel = ({providers, listings, onPageChange, selectedTab, onTabChange}) => {
  const classes = useStyles();
  const listingsTabLabel = `Offers & Listings (${listings.total})`;
  const providersTabLabel = `Service Providers (${providers.total})`;
  // const blogTabLabel = 'Blog Articles (0)';

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <StyledTabs value={selectedTab} onChange={onTabChange} aria-label="Tabs">
          <StyledTab label={listingsTabLabel} aria-label="Offers and listings tab selector" {...a11yProps(0)} />
          <StyledTab label={providersTabLabel} aria-label="Service providers tab selector" {...a11yProps(1)} />
          {/*<StyledTab label={blogTabLabel} aria-label="Blog articles tab selector" {...a11yProps(2)} />*/}
        </StyledTabs>
      </AppBar>
      <TabPane value={selectedTab} index={0} className={classes.tabContent}>
        {listings.total > 0 ? (
          <Typography variant="body2" className={classes.paginationText}>
            {listings.paginationText} Offers and Listings.
          </Typography>
        ) : null}
        <ListingsCardList
          isLoading={listings.isLoading}
          data={listings.data}
          nullMessage='Sorry, we didn&apos;t find any Offers & Listings that matched your search query.'
        />
        {listings.total > 0 ? (
          <React.Fragment>
            <Typography variant="body2" className={classes.paginationText}>
              {listings.paginationText} Offers and Listings. Select page:
            </Typography>
            <Pagination
              count={listings.pageCount}
              page={listings.currentPage}
              variant="outlined"
              shape="rounded"
              onChange={onPageChange}
            />
          </React.Fragment>
        ) : null}
      </TabPane>
      <TabPane value={selectedTab} index={1} className={classes.tabContent}>
        {providers.total > 0 ? (
          <Typography variant="body2" className={classes.paginationText}>
            {providers.paginationText} Service Providers.
          </Typography>
        ) : null}
        <ProviderCardList
          isLoading={providers.isLoading}
          data={providers.data}
          nullMessage='Sorry, we didn&apos;t find any Service Providers that matched your search query.'
        />
        {providers.total > 0 ? (
          <React.Fragment>
            <Typography variant="body2" className={classes.paginationText}>
              {providers.paginationText} Service Providers. Select page:
            </Typography>
            <Pagination
              count={providers.pageCount}
              page={providers.currentPage}
              variant="outlined"
              shape="rounded"
              onChange={onPageChange}
            />
          </React.Fragment>
        ) : null}
      </TabPane>
      {/*
        <TabPane value={selectedTab} index={2} className={classes.tabContent}>
        </TabPane>
      */}
    </div>
  );

};

TabsPanel.propTypes = {
  providers: PropTypes.object.isRequired,
  listings: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  selectedTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default TabsPanel;
